import { render, staticRenderFns } from "./InstallDoctorPage.vue?vue&type=template&id=a1b3e38e"
import script from "./InstallDoctorPage.vue?vue&type=script&lang=js"
export * from "./InstallDoctorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports